var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.25H20.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 7.875C16.4062 8.28921 16.742 8.625 17.1562 8.625C17.5705 8.625 17.9062 8.28921 17.9062 7.875H16.4062ZM17.9062 5.625C17.9062 5.21079 17.5705 4.875 17.1562 4.875C16.742 4.875 16.4062 5.21079 16.4062 5.625H17.9062ZM9.09375 7.875C9.09375 8.28921 9.42954 8.625 9.84375 8.625C10.258 8.625 10.5938 8.28921 10.5938 7.875H9.09375ZM10.5938 5.625C10.5938 5.21079 10.258 4.875 9.84375 4.875C9.42954 4.875 9.09375 5.21079 9.09375 5.625H10.5938ZM7.875 7.125C6.83947 7.125 6 7.96447 6 9H7.5C7.5 8.79289 7.66789 8.625 7.875 8.625V7.125ZM19.125 7.125H7.875V8.625H19.125V7.125ZM21 9C21 7.96447 20.1605 7.125 19.125 7.125V8.625C19.3321 8.625 19.5 8.79289 19.5 9H21ZM21 20.25V9H19.5V20.25H21ZM19.125 22.125C20.1605 22.125 21 21.2855 21 20.25H19.5C19.5 20.4571 19.3321 20.625 19.125 20.625V22.125ZM7.875 22.125H19.125V20.625H7.875V22.125ZM6 20.25C6 21.2855 6.83947 22.125 7.875 22.125V20.625C7.66789 20.625 7.5 20.4571 7.5 20.25H6ZM6 9V20.25H7.5V9H6ZM17.9062 7.875V7.73438H16.4062V7.875H17.9062ZM17.9062 7.73438V5.625H16.4062V7.73438H17.9062ZM10.5938 7.875V7.73438H9.09375V7.875H10.5938ZM10.5938 7.73438V5.625H9.09375V7.73438H10.5938Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.eea9024b.svg";
export { ForwardRef as ReactComponent };